import { render, staticRenderFns } from "./v-group-select.vue?vue&type=template&id=2771b50d&"
import script from "./v-group-select.vue?vue&type=script&lang=js&"
export * from "./v-group-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports